module.exports = __webpack_public_path__ + "static/media/insta-4-min.b20452bc.png";